<div class="renderer-container" (click)="$event.stopPropagation(); updateSelection()">

  <span [innerHTML]="primary | searchMatch:searchStr"></span>
  <small *ngIf="secondary" [innerHTML]="secondary | searchMatch: searchStr"></small>

</div>

